<template>
    <div class="about2">
        <!--顶部介绍-->
        <picture>
            <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/bakTop.png">
            <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/bakTop.png">
            <img class="bakTop" src="@/assets/img/pc/about/about2/bakTop.png">
        </picture>
        <breadcrumb :guide="guide"></breadcrumb>
        <!--主体内容-->
        <div class="x-container">
            <!--空数据-->
            <div class="no-data" v-if="showNoData">
                暂无数据
            </div>
            <div class="content">
                <section class="box-card" v-for="(item, index) in softList" :key="index">
                    <div class="title" :title="item.name">
                        {{ item.name }}
                    </div>
                    <div class="description" :title="item.description">
                        {{ item.description }}
                    </div>
                    <div class="bottom">
                        <div class="image-div">
                            <img class="soft-img" :src="require('../../../assets/img/logic.png')"
                                v-if="item.type === 1" />
                            <img class="soft-img" :src="require('../../../assets/img/手机APP.png')" v-else />
                        </div>
                        <div class="soft-detail-div">
                            <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
                                <div>
                                    <p class="soft-value">{{ item.version }}</p>
                                    <p class="soft-label">版本</p>
                                </div>
                                <el-divider direction="vertical"></el-divider>
                                <div>
                                    <p class="soft-value">{{ item.size }}</p>
                                    <p class="soft-label">大小</p>
                                </div>
                                <el-divider direction="vertical"></el-divider>
                                <div>
                                    <p class="soft-value">{{ item.environment }}</p>
                                    <p class="soft-label">环境</p>
                                </div>
                                <el-divider direction="vertical"></el-divider>
                                <div>
                                    <p class="soft-value">{{ item.updateTime }}</p>
                                    <p class="soft-label">更新时间</p>
                                </div>
                            </div>
                            <div class="update-record">
                                <p>更新日志</p>
                                <p class="record-item" v-html="formatUpdateRecord(item.updateRecordList)"
                                    style="white-space: pre-line; word-break: break-word; padding: 5px 0;"></p>
                            </div>
                            <div class="download-btn">
                                <el-button type="primary" @click="downloadSoft(item)">立即下载</el-button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb';
import { mapGetters, mapActions } from "vuex";
import { selectSoftwareInPublish, downloadSoftware } from "@/api/softDownload";
import { exportMethod, exportMethod2 } from "@/utils/fileExports";
import { needLogin, hasAuthority } from "@/utils/needLoginList";
import { shakeMessage } from "@/utils/shakeMsg";
import qs from "qs";
export default {
    name: "softDownload",
    components: {
        breadcrumb,
    },
    computed: {
        showNoData() {
            if (this.softList.length === 0) {
                return true;
            }
            return false;
        },
        ...mapGetters(['getUserName']),
    },
    data() {
        return {
            guide: [
                { label: '服务与支持' },
                { label: '软件下载' },
            ],
            softList: [],
        }
    },
    methods: {
        ...mapActions(['openLoginDailog']),
        formatUpdateRecord(text) {
            if (!text) return '';
            return text.replace(/\n/g, '<br>');
        },
        downloadSoft(item) {
            if (this.getUserName) {
                if (hasAuthority('/softDownload')) {
                    let params = {
                        id: item.id,
                        username: this.getUserName,
                        fileName: item.type === 1 ? 'GMVisual Logic.zip' : 'Gree GMOS+手机APP.zip',
                    };
                    let data = {
                        url: 'api/software/downloadSoftware',
                        params: qs.stringify(params)
                    };
                    exportMethod2(data);
                } else {
                    shakeMessage("很抱歉，您没有下载权限", 'warning');
                }
            } else {  // 未登录则弹出登录框
                this.openLoginDailog();
            }
        },
        getSoftList() {
            selectSoftwareInPublish().then((res) => {
                if (res.returnCode === 100) {
                    this.softList = [];
                    this.softList = res.returnData;
                    this.softList.map((item) => {
                        item.name = item.type === 1 ? 'GMVisual Logic' : 'GREE GMOS+手机APP';
                        item.description = item.type === 1 ? '控制逻辑开发工具，内置丰富的协议组件、逻辑组件，支持简易开发应用软件' : '搭配GMVisual Master、GMLink IoT物联网关/智控柜使用，实现手机端监控、能源管理、设备运维';
                        // item.imageUrl = item.type === 1 ? '../../../assets/img/logic.png' : '../../../assets/img/手机APP.png';
                        item.size = item.fileSize + 'MB';
                        item.environment = item.operatingEnvironment;
                        item.updateRecordList = item.updateLog;
                        item.updateTime = item.updateTime.split(' ')[0];
                    })
                }
            })
        },
    },
    mounted() {
        this.getSoftList();
    },
    destroyed() {

    },
}
</script>

<style scoped lang="less">
/*头部背景图*/
.bakTop {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
}
</style>
<style lang="less" scoped>
.box-card {
    text-align: left;
    margin-top: 1.25rem;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    box-sizing: border-box;
    padding: 1.25rem;
    font-size: 1rem;
    width: 80%;
    margin: 0 auto;
}

.box-card:nth-child(n + 2) {
    margin-top: 1.25rem;
}

@media only screen and (max-width: 797px) {
    .image-div {
        width: 100%;
        margin-bottom: 0.5rem;
    }

    .soft-detail-div {
        width: 100%;
    }

    /deep/ .download-btn {
        .el-button {
            font-weight: bold;
        }
    }
}

@media only screen and (min-width: 798px) {
    .image-div {
        width: 46%;
    }

    .soft-detail-div {
        width: 50%;
    }
}

.x-container {
    color: #333333;
    padding-top: 0;
    @media (min-width: 1200px) {
        width: 1600px !important;
    }
}

.title {
    font-weight: bold;
    margin-bottom: 0.5rem;
}

.soft-img {
    width: 100%;
    aspect-ratio: 1.88;
}

.bottom {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.description {
    margin-bottom: 0.5rem;
    font-size: 0.85rem;
    color: #666666;
}

.soft-value {
    color: #4d4d4d;
    font-size: 0.8rem;
}

.soft-label {
    font-size: 0.7rem;
    color: #808080;
}

.update-record {
    margin-top: 0.5rem;
    font-size: 0.7rem;
    color: #666666;
}

.record-item {
    margin-top: 5px;
}

.download-btn {
    text-align: center;
    margin-top: 0.5rem
}

/deep/ .el-divider--vertical {
    margin: 0 0.3rem;
    height: 2.2em;
}

/deep/ .download-btn {
    .el-button {
        padding: 0.5rem;
        font-size: 0.8rem;
        background: linear-gradient(to right, #158cff, #29abe2);
    }
}

@media only screen and (max-width: 767px) {
    .box-card {
        width: 100%;
    }
}
</style>
